import { render, staticRenderFns } from "./SpacerMenu.vue?vue&type=template&id=7bf2fa40&"
import script from "./SpacerMenu.vue?vue&type=script&lang=js&"
export * from "./SpacerMenu.vue?vue&type=script&lang=js&"
import style0 from "./SpacerMenu.vue?vue&type=style&index=0&id=7bf2fa40&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports